import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { KalturaLogger } from '@kaltura-ng/kaltura-logger';
import { BrowserService } from 'app-shared/kmc-shell/providers/browser.service';
import { Title } from '@angular/platform-browser';
import { AppLocalization } from '@kaltura-ng/mc-shared';
import { ContextualHelpService } from 'app-shared/kmc-shared/contextual-help/contextual-help.service';
import { KmcMainViewBaseService, ViewMetadata } from '../kmc-main-view-base.service';
import { KMCPermissions, KMCPermissionsService } from '../../kmc-permissions';

@Injectable()
export class ContentEntriesMainViewService extends KmcMainViewBaseService {
  constructor(
    logger: KalturaLogger,
    browserService: BrowserService,
    router: Router,
    private _appPermissions: KMCPermissionsService,
    appLocalization: AppLocalization,
    titleService: Title,
    contextualHelpService: ContextualHelpService,
  ) {
    super(
      appLocalization,
      logger.subLogger('ContentEntriesMainViewService'),
      browserService,
      router,
      titleService,
      contextualHelpService,
    );
  }

  isAvailable(): boolean {
    return this._appPermissions.hasAnyPermissions([
      KMCPermissions.CONTENT_MANAGE_BASE,
      KMCPermissions.CONTENT_MANAGE_METADATA,
      KMCPermissions.CONTENT_MANAGE_ASSIGN_CATEGORIES,
      KMCPermissions.CONTENT_MANAGE_THUMBNAIL,
      KMCPermissions.CONTENT_MANAGE_SCHEDULE,
      KMCPermissions.CONTENT_MANAGE_ACCESS_CONTROL,
      KMCPermissions.CONTENT_MANAGE_CUSTOM_DATA,
      KMCPermissions.CONTENT_MANAGE_EMBED_CODE,
      KMCPermissions.CONTENT_MANAGE_DELETE,
      KMCPermissions.CONTENT_MANAGE_RECONVERT,
    ]);
  }

  getRoutePath(): string {
    return 'content/entries';
  }

  getViewMetadata(): ViewMetadata {
    return {
      viewKey: 'content-entries',
      title: this._appLocalization.get('app.titles.contentEntriesPageTitle'),
      menu: this._appLocalization.get('app.titles.contentEntriesMenuTitle'),
    };
  }
}
